"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanVariableStore = void 0;
class PlanVariableStore {
    data = {};
    add(item) {
        this.data[item.getId()] = item;
    }
    byId(id) {
        return this.data[id];
    }
    query(options) {
        return Object.values(this.data).filter(p => {
            if (options.branchId && p.getBranchId() != options.branchId) {
                return false;
            }
            return true;
        });
    }
    delete(id) {
        throw new Error("Method not implemented.");
    }
}
exports.PlanVariableStore = PlanVariableStore;
